import ModelUtil from '@leverege/model-util';
import Attributes from "../../attribute/Attributes.js";
import ArrayDetailModel from "./ArrayDetailModel.js";
const TYPE = 'attr.detail.ArrayGeneric';
function getName(data) {
  return Attributes.getDisplayName(data.attrName, data.objectType);
}

// These are common, make them once
const base = {
  ...ArrayDetailModel,
  getName,
  ...ModelUtil.createAllValue('formatter'),
  ...ModelUtil.createAllValue('i18nResolver')
};
delete base.create;
function create(attrName, objectType) {
  return ArrayDetailModel.create(TYPE, {
    attrName,
    objectType
  });
}
function createFor(type) {
  return {
    create: (attrName, objectType) => {
      return ArrayDetailModel.create(type, {
        attrName,
        objectType
      });
    },
    ...base
  };
}
export default {
  TYPE,
  create,
  createFor,
  ...base
};